import '../../benetech/js/initialize';

import '../../benetech/js/components/site-header';
import '../../benetech/js/components/hero';
import '../../benetech/js/components/modal-grid';
import '../../benetech/js/components/testimonials';
import './components/megamenu'
import './components/tabs'
import './components/gallery'
import './components/accordion'

import '../../benetech/js/templates/full-width-hero';
import './templates/full-width-hero';



// WEBPACK FOOTER //
// ./js/main.js